import {
  booleanAttribute,
  Component,
  computed,
  HostBinding,
  input,
  output,
} from '@angular/core';
import { ButtonSeverity } from 'primeng/button';

type ButtonAction = 'default' | 'positive' | 'negative';
type ButtonPreset = 'default' | 'form-submit' | 'form-cancel';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  standalone: false,
})
export class ButtonComponent {
  buttonAction = input<ButtonAction>('default');
  disabled = input(false, { transform: booleanAttribute });
  fullSize = input(false, { transform: booleanAttribute });
  label = input<string>();
  actionType = input<string>('button');
  severity = input<ButtonSeverity>();
  variant = input<'outlined' | 'text' | undefined>();
  rounded = input<boolean>(false);
  size = input<'small' | 'large' | undefined>();
  styleClass = input<string>();
  preset = input<ButtonPreset>('default');
  loading = input(false, { transform: booleanAttribute });

  private readonly presetClasses: Record<ButtonPreset, string> = {
    default: '',
    'form-submit':
      'form-preset w-[120px] h-12 min-h-[48px] !bg-blue-700 !border-blue-700 !text-white font-medium text-sm px-5 py-3 !rounded-md hover:!bg-blue-800 hover:!border-blue-800 disabled:!bg-slate-400 disabled:!border-slate-400 disabled:!opacity-100 disabled:cursor-not-allowed',
    'form-cancel':
      'form-preset w-[120px] h-12 min-h-[48px] gap-2 !bg-slate-50 !border !border-slate-200 !text-slate-600 font-medium text-sm px-5 py-3 !rounded-md hover:!bg-slate-100 hover:!border-slate-300 disabled:!opacity-50 disabled:cursor-not-allowed',
  };

  buttonClass = computed(() => {
    const presetClass = this.presetClasses[this.preset()];
    const additionalClass = this.styleClass();

    return [presetClass, additionalClass].filter(Boolean).join(' ');
  });

  handleClick = output<MouseEvent>();

  onClick($event: MouseEvent) {
    this.handleClick.emit($event);
  }

  @HostBinding('class.fullSize')
  get isFullSize() {
    return this.fullSize();
  }
}
